// KILLING OVER WATER - Universe Data
// Complete canonical structure — single source of truth for the entire universe

export const eras = [
  {
    id: 1,
    years: "1919–1945",
    title: "THE BULLIES OF NEW YORK",
    locked: false,
    description: "The origin of all KOW money. A multiracial Anti-Mafia organization — the Morelli Family, the Harlem Hoodlums, the Jam Rockers of Nostrand Ave, and the Jaded Blade — operated a policy bank across Harlem and Brooklyn. Every dollar downstream traces back to this bank. The Chavez Brothers ran with the network. Francisco Moreno Sr. was killed by The Table. Frankie Jr. went to war. Annora held the secrets. Winston Johnston smuggled ganja. The Bullies were the first to kill over water."
  },
  {
    id: 2,
    years: "1945–1965",
    title: "THE FRACTURE",
    locked: false,
    description: "Francisco Sr. killed by The Table. Tio Johnston born — son of Annora and Winston. Frankie returns from WW2 and discovers Rizzo's betrayal — the real federal informant who brought down The Table was never the Morellis. Frankie chooses silence to protect family. The Bullies network fractures. Maurice grows up in the Bronx, never fully claimed by either side. The policy bank money disperses through multiple hands, boroughs, and generations. Seeds planted in Flatbush begin to root."
  },
  {
    id: 3,
    years: "1965–1979",
    title: "ORIGINS",
    locked: false,
    description: "Antwan and 5-year-old Anton arrive from Jamaica at JFK. Meet Tio and Vincent. Move to East New York. Tio runs a double life as MTA conductor and drug trafficker. Anton and Vincent bond. Rodriguez joins NYPD after Vietnam. 1977 Blackout looting. Tio's Polo Grounds connect with Shoggy. Anton's first taste of the streets."
  },
  {
    id: 4,
    years: "1979–1987",
    title: "CMD RISE",
    locked: false,
    description: "Tio is murdered at the docks by the Ski crew. Vincent witnesses his father's death. Antwan takes over and trains Anton and Vincent. CMD officially forms with Goonie, Dino, Manny. Anton sent to Spofford juvenile facility — where the brotherhood is forged. Tio's funeral — Black Israelites and De La Toros attend. The Chainsaw lesson. CMD destroys the Ski crew. Ark arrives from Oklahoma with the first crack cook operation."
  },
  {
    id: 5,
    years: "1987–1991",
    title: "MONEY POWER DISTRICT",
    locked: false,
    description: "CMD at peak power — controls Brooklyn, expanding into Queens and Staten Island. Anton meets Claude Devoe and learns money laundering. The electronics store empire is born. Rodriguez descends after personal tragedy, becomes a vigilante. The Morelli crime family enters the picture. Francisco Morelli becomes Anton's grandfather figure and dangerous ally. Anton meets Jordan in Newark — Jersey expansion. Francisco warns CMD of the task force. Diego finds the Peruvian connect in Maryland. The playground shooting breaks the 'no innocent lives' code."
  },
  {
    id: 6,
    years: "1991–1998",
    title: "SKI MASK WAY",
    locked: false,
    description: "Francisco sentenced to life. CMD scatters — Anton exiled to Richmond, Vincent to Maryland. Rosa emerges as 'The Ghost of Sunset Park.' BGM forms in the Bronx. Los Diablos arrive from California. The streets reorganize. Gloria discovers she's pregnant with Anton's child — Lena is conceived. PAW (Pills and Weed) forms. Rico records first demo."
  },
  {
    id: 7,
    years: "1998–2006",
    title: "MONEY PARK GANG",
    locked: false,
    description: "CMD ghosts reposition. Anton in electronics. Vincent in real estate. A mysterious nightclub opens on the West Coast — someone from the old world starts fresh. The MPG five are introduced: Red Eye, Ty, Cash, and others. The DDN (Dominican Dope Nation) rises under Raul. Big Rich goes platinum. MPG becomes transporters for DDN. Fuego's cartel war. Big Rich shouts out MPG on platinum album. The ghosts begin to stir in Brooklyn."
  },
  {
    id: 8,
    years: "2006–2026",
    title: "V.I.P.",
    locked: false,
    description: "A man left his past behind with one idea: build something nobody could touch. A prestige nightclub in Los Angeles where the staff fights for money, status, and survival — while the owner hides a past tied to Coke Money District. Everything revolves around one metric: who sells the most VIP tables. The monthly competition drives rivalries, alliances, sabotage, romance, and secrets. What happens in LA nightclubs — and the Persians who circle there — will explode on the Brooklyn waterfront twenty years later."
  },
  {
    id: 9,
    years: "2026",
    title: "THE WATERFRONT DISTRICT",
    locked: false,
    description: "A casino opened on the Brooklyn waterfront the same night a man walked out of prison after twenty years. Anton returns not for revenge — but for Monopoly. Juny emerges from military service with discipline and a double identity. Someone from YN Nation is secretly tapping into a California network with deep CMD roots. The old connections run deeper than anyone knows."
  }
];

export const books = [
  {
    id: 1,
    title: "COKE MONEY DISTRICT",
    years: "1965 – 1989",
    status: "Coming Soon",
    available: false,
    teaser: "It started with Coke money. First you get the money... What began with street corners, ski masks, and fast cash grows into a force powerful enough to rival old-world crime families. Anton, ruthless and calculating, leads CMD with a vision to transform dirty money into legitimate power. Beside him stands his cousin Vincent, sharp and composed, and Diego — the enforcer who makes problems disappear. This is the rise.",
    chapters: null,
    leadsTo: "Book 2"
  },
  {
    id: 2,
    title: "MONEY POWER RESPECT",
    subtitle: null,
    years: "1990 – 1992",
    status: "Coming Soon",
    available: false,
    teaser: "The crown is within reach. CMD at peak power. Francisco Morelli enters the picture. The Feds close in. The task force forms. The playground shooting changes everything. And the betrayal that scatters an empire begins to take shape.",
    chapters: [
      { number: 1, title: "The Fall of Francisco", description: "The old-world patriarch sentenced to life. His name still commands fear. Anton carries his bloodline." },
      { number: 2, title: "The Scattering", description: "CMD fractures. Anton exiled to Richmond. Vincent to Maryland. The empire scatters to the wind." },
      { number: 3, title: "The Peruvian Connect", description: "Diego finds the pipeline in Maryland. Ninety-two percent pure. The supply that would fuel an empire." },
      { number: 4, title: "The Playground", description: "The shooting that breaks the code. No innocent lives — but the streets don't follow rules." },
      { number: 5, title: "The Jersey War", description: "Anton meets Jordan in Newark. The expansion into New Jersey territory. New alliances, new enemies." },
      { number: 6, title: "The Electronics Empire", description: "Claude Devoe's lesson made real. Dirty money flows through legitimate storefronts. The wash begins." },
      { number: 7, title: "The Task Force", description: "The Feds assemble. Agent Warner takes the lead. Francisco warns CMD — but it may be too late." },
      { number: 8, title: "The Setup", description: "Someone makes a call. Someone opens a door. The betrayal that will define twenty years begins." },
      { number: 9, title: "The Betrayal", description: "The fall. Anton goes down. The empire shatters. And the water remembers who made the call." }
    ],
    leadsTo: "Book 3"
  },
  {
    id: 3,
    title: "SKI MASK WAY",
    years: "1992 – 1998",
    status: "Summer 2026",
    available: false,
    teaser: "The crown is heavy. The Feds close in. Anton orchestrates the Los Diablos Heist — the job that changes everything. Rico puts in work for CMD before the music calls him. The old rules shatter. The fallout sends Anton to federal prison and scatters the empire.",
    chapters: null,
    leadsTo: "Book 4"
  },
  {
    id: 4,
    title: "MONEY PARK GANG",
    years: "1998 – 2006",
    status: "2026",
    available: false,
    teaser: "The East Coast and West Coast collide. Rico — now Big Rich — and the rising rap group MPG get endorsed through Boro Gem Music. CMD transforms into City Made Dynasty — a legitimate record label. The music covers the money. The money builds the future.",
    chapters: null,
    leadsTo: "Book 5"
  },
  {
    id: 5,
    title: "THE WATERFRONT DISTRICT",
    years: "2026",
    status: "2027",
    available: false,
    teaser: "A casino opened on the Brooklyn waterfront the same night a man walked out of prison after twenty years. Everything ends where it began. The water. The reckoning.",
    chapters: null,
    leadsTo: null
  }
];

export const characters = [
  // === THE BULLIES OF NEW YORK (1919–1945) ===
  {
    id: 52,
    name: 'FRANCISCO MORENO SR.',
    era: "Bullies Era",
    age: null,
    role: "Policy Bank Patriarch",
    archetype: "The Original Source",
    faction: "The Bullies of New York",
    image: null,
    imageClassified: false,
    description: "Moreno family patriarch. Policy bank operator. Allied with the Morellis and the full Bullies network. Every dollar in the KOW universe traces back to his operation. Killed by The Table circa 1945.",
    status: "DECEASED",
    statusDetail: "Killed by The Table, ~1945",
    dossier: {
      subject: "FRANCISCO MORENO SR.",
      aliases: "The Banker",
      origin: "Harlem / Brooklyn",
      active: "1919 — 1945",
      associates: "The Bullies of New York, Harlem Hoodlums, Jam Rockers, Morelli Family",
      method: "Policy bank operations across Harlem and Brooklyn. The financial engine of the Bullies.",
      strengths: "Financial genius, alliance builder, trusted across racial lines",
      flaws: "Trusted Rizzo. Left secrets only with Annora.",
      secretWound: "His money never died. It passed through generations who never knew its origin.",
      threatLevel: 5,
      quote: "Every dollar they fight over today was mine first."
    }
  },
  {
    id: 53,
    name: 'FRANCISCO "FRANKIE" MORENO JR.',
    era: "Bullies → Fracture",
    age: null,
    role: "The Keeper of Secrets",
    archetype: "The Silent Protector",
    faction: "The Bullies of New York",
    image: null,
    imageClassified: false,
    description: "Francisco Sr.'s son. At 15 ran with the Harlem Hoodlums. Fathered Maurice — a biracial son — in 1936. Enlisted in WW2. Returned to find his father dead and Rizzo's betrayal. Chose family loyalty over truth — a decision that poisoned everything downstream.",
    status: "DECEASED",
    statusDetail: "Natural causes",
    dossier: {
      subject: "FRANCISCO 'FRANKIE' MORENO JR.",
      aliases: "Frankie, The Keeper",
      origin: "Harlem, New York",
      active: "1936 — 1960s",
      associates: "Harlem Hoodlums, Annora, Leon, Maurice",
      method: "Silence. He chose to protect Rizzo and let the Morellis carry the blame for a betrayal they didn't commit.",
      strengths: "Loyalty, courage, wartime discipline",
      flaws: "His silence created a fracture that lasted generations. Ronald Morelli's hatred traces directly to Frankie's choice.",
      secretWound: "Knows Rizzo — not the Morellis — was the federal informant who brought down The Table.",
      threatLevel: 3,
      quote: "Some truths protect. Some truths destroy. You don't always get to choose which."
    }
  },
  {
    id: 54,
    name: 'MAURICE MORELLI',
    era: "Bullies → Fracture",
    age: null,
    role: "The Erased Heir",
    archetype: "Moses Fleetwood Walker",
    faction: "Morelli Bloodline",
    image: null,
    imageClassified: false,
    description: "Born 1936. Biracial son of Frankie and a Black waitress. Raised by Annora. Strong Italian features but his other heritage visible. The Moses Fleetwood Walker of the KOW universe — came before the world was ready, erased from the history books.",
    status: "DECEASED",
    statusDetail: "His grandsons carry the bloodline",
    dossier: {
      subject: "MAURICE MORELLI",
      aliases: "The First Son",
      origin: "Raised Bronx / Spanish Harlem",
      active: "1936 — Unknown",
      associates: "Annora, Frankie Jr., Italian and Spanish communities of the Bronx",
      method: "Survival in a world that wouldn't claim him. Blended into Italian and Spanish communities.",
      strengths: "Resilience, street intelligence, ability to move between worlds",
      flaws: "Never hated Anton because of race — hated him because Anton got to BE what Maurice was supposed to be from birth.",
      secretWound: "Deserved his walk. Ronald did not.",
      threatLevel: 4,
      quote: "I was the first. They just didn't want to remember."
    }
  },
  {
    id: 55,
    name: 'ANNORA',
    era: "Bullies → Fracture",
    age: null,
    role: "The Connective Tissue",
    archetype: "The Bridge Between Worlds",
    faction: "The Bullies of New York",
    image: null,
    imageClassified: false,
    description: "Spanish Harlem woman, one of 15 siblings. Brought in by Leon to raise 2-year-old Maurice. Tough, reliable, known throughout Harlem and East Harlem. Met Winston Johnston circa 1942. Mother of Tio Johnston. The reason the Moreno and Johnston bloodlines merge into Vincent.",
    status: "DECEASED",
    statusDetail: "Legacy: Mother of Tio, bridge between bloodlines",
    dossier: {
      subject: "ANNORA",
      aliases: "None — her name was enough",
      origin: "Spanish Harlem, New York",
      active: "1938 — Unknown",
      associates: "Leon, Frankie Jr., Winston Johnston, Maurice",
      method: "Connection. She held the secrets for Francisco Sr. and Frankie. She raised Maurice. She bore Tio.",
      strengths: "Toughness, loyalty, community respect, discretion",
      flaws: "Carried too many secrets for too many powerful men.",
      secretWound: "The connective tissue between the Moreno and Johnston worlds. Without her, Vincent Moreno doesn't exist.",
      threatLevel: 2,
      quote: "I raised boys that kings couldn't claim."
    }
  },
  {
    id: 56,
    name: 'WINSTON JOHNSTON',
    era: "Bullies Era",
    age: null,
    role: "Jamaican Pipeline",
    archetype: "The Smuggler",
    faction: "Jam Rockers of Nostrand Ave",
    image: null,
    imageClassified: false,
    description: "Jamaican ganja smuggler from Spanishtown, Jamaica. Ran with the Jam Rockers of Nostrand Ave — the Jamaican crew within the Bullies network. Met Annora circa 1942. Father of Tio Johnston.",
    status: "DECEASED",
    statusDetail: "His pipeline became Tio's, became CMD's",
    dossier: {
      subject: "WINSTON JOHNSTON",
      aliases: "The Jamaican",
      origin: "Spanishtown, Jamaica → Nostrand Ave, Brooklyn",
      active: "1930s — 1950s",
      associates: "Jam Rockers of Nostrand Ave, Annora, Bullies network",
      method: "Ganja smuggling through the Caribbean corridor. The original Johnston pipeline.",
      strengths: "Resourceful, fearless, networked across the Caribbean",
      flaws: "The pipeline never died — it just changed hands and products.",
      secretWound: "His son Tio would be murdered at the same docks Winston once smuggled through.",
      threatLevel: 3,
      quote: "The water carries everything. You just have to know the current."
    }
  },
  {
    id: 57,
    name: 'RIZZO',
    era: "Bullies → Fracture",
    age: null,
    role: "The True Informant",
    archetype: "The Hidden Betrayer",
    faction: "Morelli Family (by marriage)",
    image: null,
    imageClassified: false,
    description: "Francisco Jr.'s brother-in-law. The REAL federal informant who brought down The Table. It was never the Morellis. Francisco chose to protect Rizzo and allowed the Morellis to carry the blame — a decision that created Ronald Morelli's inherited hatred.",
    status: "DECEASED",
    statusDetail: "Killed — the last threat eliminated",
    dossier: {
      subject: "RIZZO",
      aliases: "The Rat (unknown to most)",
      origin: "Brooklyn, New York",
      active: "1930s — ~1950s",
      associates: "Francisco Jr., Morelli family (through marriage)",
      method: "Federal informant. Betrayed The Table from within while the Morellis took the blame.",
      strengths: "Deception, positioning, survival instinct",
      flaws: "His betrayal fractured the Bullies permanently. The Hoodlums and Johnstons cut ties with the Morellis because of what they thought the Morellis did.",
      secretWound: "Ronald Morelli's entire hatred — misdirected, inherited, never corrected — traces to Rizzo.",
      threatLevel: 5,
      quote: "The real rat is never the one they suspect."
    }
  },
  {
    id: 58,
    name: 'LEON',
    era: "Bullies Era",
    age: null,
    role: "The Connector",
    archetype: "The Old Guard",
    faction: "Harlem Hoodlums",
    image: null,
    imageClassified: false,
    description: "Shoggy's father. Connected to the Harlem Hoodlums and the Bullies network. Called upon by Frankie in 1938 to help with Maurice. Introduced Frankie to Annora. The direct generational link between old Harlem and Shoggy's presence at Tio's funeral.",
    status: "DECEASED",
    statusDetail: "His son Shoggy carries the lineage",
    dossier: {
      subject: "LEON",
      aliases: "None known",
      origin: "Harlem, New York",
      active: "1930s — Unknown",
      associates: "Harlem Hoodlums, Frankie Jr., Annora",
      method: "Connection and trust. The man who brought worlds together.",
      strengths: "Respected across factions, discreet, reliable",
      flaws: "Unknown",
      secretWound: "His son Shoggy pressing tribute cash into Vincent's hands at Tio's funeral = Leon's son honoring Winston and Annora's son.",
      threatLevel: 2,
      quote: "Every introduction I made changed history. They just didn't know it yet."
    }
  },
  // === CMD INNER CIRCLE ===
  {
    id: 1,
    name: 'ANTON "THE REAPER" MORELLI',
    era: "All Eras",
    age: 66,
    role: "Protagonist / Anti-hero",
    archetype: "The Returned Architect",
    faction: "CMD Inner Circle",
    image: "/characters/era2-anton.png",
    imageClassified: false,
    description: "Born Kingston Jamaica 1965. Arrived East New York age 5. Built CMD from nothing. Convicted 2006. Released 2026. Now 66. The ghost who came back with a plan.",
    status: "ACTIVE",
    statusDetail: "2026",
    dossier: {
      subject: "ANTON 'THE REAPER' MORELLI",
      aliases: "The Reaper, CMD",
      origin: "Kingston, Jamaica → East New York, Brooklyn",
      active: "1979 — Present",
      associates: "Vincent Moreno, Diego Dominguez, Claude Devoe, Demon, Goonie",
      method: "Monopoly, not mayhem. Surgical. Takes product, not cash. Everything digital.",
      strengths: "Patience, discipline, strategic genius, twenty years of thinking time",
      flaws: "[REDACTED]",
      secretWound: "[CLASSIFIED]",
      threatLevel: 5,
      quote: "Chaos is the only time people listen."
    }
  },
  {
    id: 2,
    name: "VINCENT MORENO",
    era: "All Eras",
    age: 55,
    role: "Antagonist / The Architect",
    archetype: "The Architect of the Wash",
    faction: "CMD Inner Circle",
    image: "/characters/young-vincent.png",
    imageClassified: false,
    description: "Anton's cousin and consigliere. John Jay graduate. Built a real estate and casino empire. Running the Waterfront District development.",
    status: "ACTIVE",
    statusDetail: "2026",
    dossier: {
      subject: "VINCENT MORENO",
      aliases: "The Architect, The Consigliere",
      origin: "East New York, Brooklyn",
      active: "1979 — Present",
      associates: "Anton Morelli, Diego Dominguez, Claude Devoe",
      method: "Real estate. Casinos. Legal infrastructure built on illegal foundation.",
      strengths: "Intelligence, composure, ability to pivot between street and boardroom",
      flaws: "[REDACTED]",
      secretWound: "[CLASSIFIED]",
      threatLevel: 4,
      quote: "Pressure is temporary. Ownership is forever."
    }
  },
  {
    id: 3,
    name: 'DIEGO DOMINGUEZ',
    era: "CMD → Ski Mask Way",
    age: null,
    role: "CMD Inner Circle",
    archetype: "The Exile",
    faction: "CMD Inner Circle",
    image: "/characters/era2-diego.png",
    imageClassified: false,
    description: "CMD inner circle. DC promoter. Virginia Beach. La Esquina Caliente. Left the East Coast after Anton's arrest. New identity. New city.",
    status: "ACTIVE",
    statusDetail: "Last Known: California",
    dossier: {
      subject: "DIEGO DOMINGUEZ",
      aliases: "CLASSIFIED",
      origin: "Brooklyn",
      active: "1985 — Present",
      method: "Honest work. Legal money. That's all he wanted.",
      strengths: "Charismatic, composed, emotionally intelligent, understands survival",
      flaws: "The past follows. Some people in California know where he came from.",
      secretWound: "[CLASSIFIED]",
      threatLevel: 3,
      quote: "Honest work. Legal money. That's all I wanted."
    }
  },
  {
    id: 4,
    name: "GOONIE",
    era: "CMD Rise",
    age: null,
    role: "Anton's Lieutenant",
    archetype: "The Loyal Soldier",
    faction: "CMD Inner Circle",
    image: "/characters/goonie-era1.png",
    imageClassified: false,
    description: "Anton's lieutenant. Forged brotherhood with Anton at Spofford. Trusted completely. The Bronx was his territory.",
    status: "UNKNOWN",
    dossier: {
      subject: "GOONIE",
      aliases: "None",
      origin: "Brooklyn → Bronx",
      active: "1979 — [SEALED]",
      method: "Loyalty above all. Quiet execution.",
      strengths: "Unwavering loyalty, street intelligence",
      flaws: "[REDACTED]",
      secretWound: "[SEALED]",
      threatLevel: 4,
      quote: "The quiet ones get rich."
    }
  },
  {
    id: 5,
    name: 'DEMON',
    era: "All Eras",
    age: 58,
    role: "Street Legend / Retired",
    archetype: "God of War",
    faction: "CMD Inner Circle",
    description: "Goonie's brother. Street legend. Gulf War veteran instincts never left. A head taller than everyone, shoulders that block the skyline. Voice like two tectonic plates grinding.",
    status: "ACTIVE",
    statusDetail: "Bronx",
    dossier: {
      subject: "DEMON (DESMOND BROWN)",
      aliases: "God of War",
      origin: "Brooklyn → Bronx",
      active: "1979 — Present",
      method: "When NYPD scared? Everybody in the way gets burned.",
      strengths: "Gulf War veteran, instincts never left, feared on every block",
      flaws: "[REDACTED]",
      secretWound: "[SEALED]",
      threatLevel: 4,
      quote: "When NYPD scared? Everybody in the way gets burned."
    }
  },
  {
    id: 6,
    name: 'JUNY "THE BURNER" MORENO',
    era: "Waterfront",
    age: 20,
    role: "The Heir",
    archetype: "The Heir Gone Rogue",
    faction: "CMD Inner Circle",
    image: "/characters/juny.png",
    imageClassified: false,
    description: "Vincent's son. Runs Navy Tech — a legitimate electronics shop with something underneath. Tied to Anton.",
    status: "ACTIVE",
    statusDetail: "Brooklyn",
    dossier: {
      subject: "JUNY 'THE BURNER' MORENO",
      aliases: "The Burner",
      origin: "Brooklyn → Maryland → Military → Brooklyn",
      active: "2024 — Present",
      method: "Military discipline meets street instinct. Encrypted comms. Formation tactics.",
      strengths: "Discipline, adaptability, fearlessness",
      flaws: "[REDACTED]",
      secretWound: "[SEALED]",
      threatLevel: 3,
      quote: "Plan C."
    }
  },
  {
    id: 7,
    name: "LENA",
    era: "Waterfront",
    age: 33,
    role: "DEA Agent",
    archetype: "The Hunter With A Secret Bloodline",
    faction: "Law Enforcement",
    description: "33 years old. Raised by grandparents. Atlantic Division DEA. Hunting a ghost king destabilizing the narcotics chain.",
    status: "ACTIVE",
    statusDetail: "2026",
    dossier: {
      subject: "LENA",
      aliases: "CLASSIFIED",
      origin: "Brooklyn — raised by grandparents",
      active: "2020 — Present",
      method: "DEA investigator. Maps anomalies. All threads point to one ghost.",
      strengths: "Intelligent, relentless, methodical",
      flaws: "[REDACTED]",
      secretWound: "[CLASSIFIED — SEASON 2]",
      threatLevel: 3,
      quote: "The secret explodes."
    }
  },
  {
    id: 8,
    name: "DINO",
    era: "CMD Rise",
    age: null,
    role: "CMD Associate",
    archetype: "The Fall Guy",
    faction: "CMD Inner Circle",
    description: "Solid, quiet, brutally efficient. Grew up in foster care. Disarmed a bodega owner with a broken wrist and didn't flinch. Holds East New York with Manny.",
    status: "UNKNOWN",
    statusDetail: "CLASSIFIED",
    dossier: {
      subject: "DINO",
      aliases: "None",
      origin: "Brooklyn",
      active: "1979 — [SEALED]",
      method: "Soldier. Did what was asked.",
      strengths: "Loyalty, willingness to sacrifice",
      flaws: "[REDACTED]",
      threatLevel: 2,
      quote: "[CLASSIFIED]"
    }
  },
  // === LAW ENFORCEMENT ===
  {
    id: 9,
    name: "LT. TORIBIO RODRIGUEZ",
    era: "All Eras",
    age: 72,
    role: "The Driven Lawman",
    archetype: "The System's Ghost",
    faction: "Law Enforcement",
    description: "Vietnam veteran. Pink Houses, Milford St — East New York born. Lost cousins and the whole neighborhood to the Morellis. That loss is what drives everything. Joined NYPD after Vietnam. Spent decades chasing CMD, but the Morellis were always the real target. The Ski Crew in CMD? That connection runs through Rodriguez's blood.",
    status: "ACTIVE",
    statusDetail: "NYPD",
    dossier: {
      subject: "LT. TORIBIO RODRIGUEZ — NYPD",
      aliases: "Rodriguez",
      origin: "Pink Houses / Milford St, East New York, Brooklyn",
      active: "1970 — Present",
      associates: "Gloria Rodriguez (daughter), Detective Miller (partner), Agent Maxwell Warner (DEA)",
      method: "Obsession disguised as duty. Every case, every stakeout, every sleepless night — it all traces back to what the Morellis took from Milford St.",
      strengths: "Vietnam discipline, institutional power, decades of connections, relentless",
      flaws: "The vendetta blinded him. He chased CMD when the Morellis were the ones who destroyed his family. On Vincent's payroll — $5K a week. The system consumed him.",
      secretWound: "Lost his cousins and his neighborhood to the Morellis. Pink Houses was never the same. That's what drove him into the NYPD, into CMD's orbit, into everything. Gloria's death broke what was left.",
      threatLevel: 4,
      quote: "I didn't join the force to serve. I joined to settle a debt."
    }
  },
  {
    id: 10,
    name: "GLORIA RODRIGUEZ",
    era: "Money Power District",
    age: null,
    role: "The Catalyst",
    archetype: "The Lost Daughter",
    faction: "Law Enforcement",
    description: "Rodriguez's daughter. Aspiring police officer. The connection between two worlds that should never have crossed.",
    status: "CLASSIFIED",
    dossier: {
      subject: "GLORIA RODRIGUEZ",
      aliases: "None",
      origin: "New York",
      active: "[SEALED]",
      method: "[REDACTED]",
      strengths: "Courage, ambition, love",
      flaws: "[REDACTED]",
      secretWound: "[CLASSIFIED — SEASON 2]",
      threatLevel: 2,
      quote: "The kiss on the rooftop, 1989."
    }
  },
  {
    id: 11,
    name: "AGENT MAXWELL WARNER",
    era: "Money Power District → Waterfront",
    age: 55,
    role: "DEA Agent",
    archetype: "The Federal Hunter",
    faction: "Law Enforcement",
    description: "The federal shark. More ambitious than moral. Doesn't want justice — wants glory. Uses pressure, informants, media leaks. Nearly broke CMD at Pier 17.",
    status: "ACTIVE",
    dossier: {
      subject: "AGENT MAXWELL WARNER — DEA",
      aliases: "None",
      origin: "Federal service",
      active: "1985 — Present",
      method: "Pressure. Informants. Media leaks. Leaked surveillance photos to the NY Post.",
      strengths: "Relentless, ambitious, political instinct, institutional access",
      flaws: "[REDACTED]",
      threatLevel: 4,
      quote: "You think a goddamn typo is going to save you?"
    }
  },
  {
    id: 12,
    name: "DETECTIVE MILLER",
    era: "Money Power District",
    age: 45,
    role: "NYPD Detective",
    archetype: "The Cynical Witness",
    faction: "Law Enforcement",
    description: "Rodriguez's partner. Gold Crown Victoria. A pragmatist on the borderline — surveils CMD but hesitates. His loyalties are complicated.",
    status: "ACTIVE",
    dossier: {
      subject: "DETECTIVE MILLER — NYPD",
      aliases: "None",
      origin: "New York",
      active: "1982 — Present",
      method: "Observation. Patience. Knowing when to look away.",
      strengths: "Good observational skills, survival instincts, pragmatism",
      flaws: "[REDACTED]",
      threatLevel: 2,
      quote: "The kid outsmarted the Feds with a fountain pen."
    }
  },
  // === MORELLI CRIME FAMILY ===
  {
    id: 14,
    name: 'FRANCISCO "THE OLD REAPER" MORELLI',
    era: "Money Power District",
    age: null,
    role: "Old-World Patriarch",
    archetype: "The Original Reaper",
    faction: "Morelli Crime Family",
    description: "Old-school patriarch. Sentenced to life. His name still commands fear from behind bars.",
    status: "ACTIVE",
    statusDetail: "Incarcerated — Life Sentence",
    dossier: {
      subject: 'FRANCISCO "THE REAPER" MORELLI',
      aliases: "The Reaper (Original)",
      origin: "Italy → New York",
      active: "1950s — Present (Incarcerated)",
      method: "Old-world power. Fear. Legacy.",
      strengths: "Name commands fear even from prison. Generational influence.",
      flaws: "[REDACTED]",
      secretWound: "[SEALED]",
      threatLevel: 5,
      quote: "My family's name is not for you to disparage."
    }
  },
  {
    id: 15,
    name: "MAURICE MORELLI",
    era: "Waterfront",
    age: null,
    role: "Morelli Family",
    archetype: "CLASSIFIED",
    faction: "Morelli Crime Family",
    description: "[CLASSIFIED]",
    status: "UNKNOWN",
    statusDetail: "CLASSIFIED",
    dossier: {
      subject: "MAURICE MORELLI",
      aliases: "[CLASSIFIED]",
      origin: "New York",
      active: "[CLASSIFIED]",
      method: "[CLASSIFIED]",
      threatLevel: 4,
      quote: "[CLASSIFIED]"
    }
  },
  {
    id: 16,
    name: "RONALD MORELLI",
    era: "Waterfront",
    age: null,
    role: "Morelli Family",
    archetype: "CLASSIFIED",
    faction: "Morelli Crime Family",
    description: "[CLASSIFIED]",
    status: "UNKNOWN",
    statusDetail: "CLASSIFIED",
    dossier: {
      subject: "RONALD MORELLI",
      aliases: "[CLASSIFIED]",
      origin: "New York",
      active: "[CLASSIFIED]",
      method: "[CLASSIFIED]",
      threatLevel: 4,
      quote: "[CLASSIFIED]"
    }
  },
  // === OTHER FACTIONS ===
  {
    id: 17,
    name: "ROSA",
    era: "Ski Mask Way → Waterfront",
    age: 44,
    role: "The Quiet Dagger",
    archetype: "The Ghost of Sunset Park",
    faction: "Other Factions",
    description: "Rosa harbors a secret grudge. Patience is her weapon. Silence is her shield. The quiet ones are the ones you should worry about.",
    status: "ACTIVE",
    statusDetail: "Brooklyn",
    dossier: {
      subject: "ROSA",
      aliases: "The Ghost of Sunset Park, The Quiet Dagger",
      origin: "Sunset Park, Brooklyn",
      active: "1998 — Present",
      method: "Patience. Silence. The long game.",
      strengths: "Invisible. Patient. Deadly when she moves.",
      flaws: "[REDACTED]",
      secretWound: "[SEALED]",
      threatLevel: 3,
      quote: "The quiet ones are the ones you should worry about."
    }
  },
  {
    id: 18,
    name: "TITO",
    era: "All Eras",
    age: 48,
    role: "The Old Guard",
    archetype: "The Enforcer's Enforcer",
    faction: "CMD Inner Circle",
    description: "The old guard. Rose through the ranks. Runs the street-level economy.",
    status: "ACTIVE",
    statusDetail: "Brooklyn",
    dossier: {
      subject: "TITO",
      aliases: "None",
      origin: "Brooklyn",
      active: "1987 — Present",
      method: "Street-level operations. The old way.",
      strengths: "Experience, loyalty to the structure",
      flaws: "[REDACTED]",
      threatLevel: 3,
      quote: "I've seen this pattern before."
    }
  },
  {
    id: 19,
    name: "JACOB HAL",
    era: "Waterfront",
    age: 35,
    role: "Vincent's Accountant",
    archetype: "The Nervous Number",
    faction: "Other Factions",
    description: "Mid-30s. Nervous energy. Discovered something during the investor meeting that changed everything.",
    status: "ACTIVE",
    dossier: {
      subject: "JACOB HAL",
      aliases: "None",
      origin: "New York",
      active: "2023 — Present",
      method: "Numbers. Compliance. Misdirection.",
      strengths: "Financial acumen, attention to detail",
      flaws: "[REDACTED]",
      threatLevel: 1,
      quote: "Vin... the reserve is short."
    }
  },
  {
    id: 20,
    name: "CLAUDE DEVOE",
    era: "Money Power District",
    age: 68,
    role: "Financial Architect",
    archetype: "The Sophisticate",
    faction: "Other Factions",
    description: "Silver hair, Macallan 18, Upper East Side townhouse. Looks like he owns the senators who write the laws. Architected the Waterfront District vision — turning drug cash into property empire.",
    status: "UNKNOWN",
    statusDetail: "CLASSIFIED",
    dossier: {
      subject: "CLAUDE DEVOE",
      aliases: "The Sophisticate",
      origin: "Upper East Side, Manhattan",
      active: "1987 — CLASSIFIED",
      method: "Real estate. Shell companies. A former Deputy Mayor on retainer for nuisances.",
      strengths: "Financial genius, political connections, vision, silence",
      flaws: "[CLASSIFIED]",
      threatLevel: 5,
      quote: "Real power is silent. Real power is a signature on a deed."
    }
  },
  {
    id: 21,
    name: "GUSTAV",
    era: "Waterfront",
    age: null,
    role: "Russian Faction",
    archetype: "The Uneasy Ally",
    faction: "Other Factions",
    description: "Russian mob. Initially antagonistic to CMD. Now an uneasy transactional ally to Anton.",
    status: "ACTIVE",
    statusDetail: "Russian Faction",
    dossier: {
      subject: "GUSTAV",
      aliases: "[CLASSIFIED]",
      origin: "Russia → New York",
      active: "2020s — Present",
      method: "Transactional alliances. No loyalty — only interest.",
      strengths: "Resources, muscle, international connections",
      flaws: "Trust no one. Allies today, enemies tomorrow.",
      threatLevel: 4,
      quote: "[CLASSIFIED]"
    }
  },
  {
    id: 22,
    name: "CHUCK WONG",
    era: "Waterfront",
    age: 62,
    role: "Red Serpents Leader",
    archetype: "The Silent Investor",
    faction: "Other Factions",
    description: "Leader of the Red Serpents. Controls NYC's gambling world. A silent investor with deep connections.",
    status: "UNKNOWN",
    statusDetail: "CLASSIFIED",
    dossier: {
      subject: "CHUCK WONG",
      aliases: "The Silent Investor",
      origin: "Chinatown, Manhattan",
      active: "1990s — Present",
      method: "Gambling empire. Silent moves.",
      strengths: "Controls NYC gambling. Patient. Connected.",
      flaws: "[CLASSIFIED]",
      threatLevel: 4,
      quote: "[CLASSIFIED]"
    }
  },
  {
    id: 23,
    name: "TAZZ",
    era: "Waterfront",
    age: null,
    role: "Navy Tech Second",
    archetype: "The Loyal Warning",
    faction: "Other Factions",
    description: "Juny's right hand at Navy Tech. Loyal but terrified of where Juny's ambition is leading them.",
    status: "ACTIVE",
    statusDetail: "Navy Tech",
    dossier: {
      subject: "TAZZ",
      aliases: "None",
      origin: "Brooklyn",
      active: "2024 — Present",
      method: "Loyalty. Even when it's terrifying.",
      strengths: "Loyalty, street smarts, pragmatism",
      flaws: "Knows they're in too deep. Can't leave.",
      threatLevel: 2,
      quote: "You're gonna get us all killed."
    }
  },
  {
    id: 24,
    name: "MEILIN ZHANG",
    era: "Waterfront",
    age: null,
    role: "Financial Pressure",
    archetype: "The Debt Clock",
    faction: "Other Factions",
    description: "Wants her $30K from Vincent in ten days. Part of the financial pressure closing in on the casino opening.",
    status: "ACTIVE",
    dossier: {
      subject: "MEILIN ZHANG",
      aliases: "None",
      origin: "New York",
      active: "2026",
      method: "Financial leverage. Deadlines. Pressure.",
      strengths: "Ruthless about money. Doesn't negotiate.",
      flaws: "Single-minded focus on the debt.",
      threatLevel: 3,
      quote: "Ten days, Vincent. Ten days."
    }
  },
  // === THE FOUNDATION — ORIGINS ===
  {
    id: 25,
    name: "ANTWON 'THE BULL' JOHNSTON",
    era: "Origins → CMD Rise",
    age: null,
    role: "Anton's Father / The Foundation",
    archetype: "The Bull from Kingston",
    faction: "CMD Inner Circle",
    description: "Arrived from Kingston, Jamaica with five-year-old Anton. The bull who built the foundation — muscle, mentorship, and an unbreakable bond with his son. The reason CMD exists.",
    status: "CLASSIFIED",
    statusDetail: "[SEALED]",
    dossier: {
      subject: "ANTWON 'THE BULL' JOHNSTON",
      aliases: "The Bull, Antwan",
      origin: "Kingston, Jamaica → East New York, Brooklyn",
      active: "1970s — [SEALED]",
      associates: "[REDACTED]",
      method: "Muscle and mentorship. Taught by example. Never backed down.",
      strengths: "Physical presence, loyalty, street intelligence, unwavering discipline",
      flaws: "[REDACTED]",
      secretWound: "[SEALED]",
      threatLevel: 4,
      quote: "You don't raise a king by being soft. You raise him by being present."
    }
  },
  {
    id: 26,
    name: "TIO JOHNSTON 'THE FARMER'",
    era: "Origins",
    age: null,
    role: "Vincent's Father / The Network",
    archetype: "The Double Life",
    faction: "CMD Inner Circle",
    description: "MTA train conductor by day. Vincent's father. The farmer who planted the seeds of everything CMD would become.",
    status: "CLASSIFIED",
    statusDetail: "[SEALED]",
    dossier: {
      subject: "TIO JOHNSTON",
      aliases: "The Farmer, Tio",
      origin: "East New York, Brooklyn",
      active: "1970s — [SEALED]",
      associates: "[REDACTED]",
      method: "Trains. Docks. Pipelines. A conductor who moved more than people.",
      strengths: "Network architecture, discipline, patience, dual-identity mastery",
      flaws: "[REDACTED]",
      secretWound: "[SEALED]",
      threatLevel: 3,
      quote: "I'm a conductor. I move things. That's all you need to know."
    }
  },
  {
    id: 27,
    name: "MARIA MORENO",
    era: "Origins",
    age: null,
    role: "Vincent's Mother",
    archetype: "The Matriarch",
    faction: "CMD Inner Circle",
    description: "[FILE CLASSIFIED] — The woman who held the household together while Tio ran the streets. Welcomed Anton into her home. Raised Vincent. The matriarch who saw everything and said nothing — until the water made her speak.",
    status: "CLASSIFIED",
    statusDetail: "[REDACTED]",
    dossier: {
      subject: "MARIA MORENO",
      aliases: "[CLASSIFIED]",
      origin: "East New York, Brooklyn",
      active: "[CLASSIFIED]",
      associates: "Tio Johnston, Vincent Moreno, Anton Morelli, Antwon Johnston",
      method: "[FILE CLASSIFIED]",
      strengths: "Observation. Patience. The ability to hold silence for decades.",
      flaws: "[CLASSIFIED]",
      secretWound: "[FILE CLASSIFIED — THE WATER KEEPS THIS ONE]",
      threatLevel: 2,
      quote: "You must be Anton... Welcome home."
    }
  },
  {
    id: 28,
    name: "FILOMENA MORELLI",
    era: "Origins",
    age: null,
    role: "Anton's Mother",
    archetype: "The Ghost of Kingston",
    faction: "CMD Inner Circle",
    description: "[FILE CLASSIFIED] — A Morelli by blood. A ghost by choice. Anton's mother. The woman who stayed behind when Antwon took Anton to America — or the woman who was already gone before they left. The water knows her name. The water keeps her secrets.",
    status: "CLASSIFIED",
    statusDetail: "[REDACTED]",
    dossier: {
      subject: "FILOMENA MORELLI",
      aliases: "[CLASSIFIED]",
      origin: "Kingston, Jamaica",
      active: "[CLASSIFIED]",
      associates: "Antwon Johnston, Anton Morelli, Francisco Morelli",
      method: "[FILE CLASSIFIED]",
      strengths: "Morelli bloodline. Connections that run deeper than Brooklyn.",
      flaws: "[CLASSIFIED]",
      secretWound: "[FILE CLASSIFIED — A MORELLI BY BLOOD. THE WATER REMEMBERS WHAT KINGSTON FORGOT.]",
      threatLevel: 1,
      quote: "Some ghosts don't haunt. They wait."
    }
  },
  {
    id: 29,
    name: 'PAPI',
    era: "Los Diablos",
    age: null,
    role: "Antagonist",
    archetype: "The Devil of California",
    faction: "Los Diablos",
    image: "/characters/papi.png",
    imageClassified: false,
    description: "Leader of Los Diablos. Arrived from California with a network and a grudge. The heist that changed everything started with his name. Now he's back for the waterfront.",
    status: "ACTIVE",
    statusDetail: "Last Known: Brooklyn Waterfront",
    dossier: {
      subject: "PAPI — LOS DIABLOS",
      aliases: "CLASSIFIED",
      origin: "California",
      active: "1990s — Present",
      associates: "[CLASSIFIED]",
      method: "Old school. Ruthless. Knows every angle before you take a step.",
      strengths: "Patience, network, California-to-East-Coast pipeline",
      flaws: "Pride. The waterfront obsession.",
      secretWound: "[CLASSIFIED — LOS DIABLOS FILE]",
      threatLevel: 4,
      quote: "You don't take what's mine. You borrow it. And I always collect."
    }
  },
  {
    id: 30,
    name: 'RICO "BIG RICH"',
    era: "Ski Mask Way → Ghosts Reposition",
    age: null,
    role: "CMD Associate / Music Mogul",
    archetype: "The Culture Pipeline",
    faction: "CMD Inner Circle",
    image: "/characters/big-rich.png",
    imageClassified: false,
    description: "Started recording demos in the CMD era. Went platinum as Big Rich. The music covers the money.",
    status: "ACTIVE",
    statusDetail: "Music Industry",
    dossier: {
      subject: "RICO — 'BIG RICH'",
      aliases: "Big Rich, Rico",
      origin: "Brooklyn",
      active: "1990s — Present",
      method: "The culture was always the cleanest pipeline. Records, labels, tours.",
      strengths: "Charisma, cultural influence, connects the street to the mainstream",
      flaws: "[REDACTED]",
      secretWound: "[CLASSIFIED]",
      threatLevel: 2,
      quote: "The music covers the money. The money builds the future."
    }
  },
  // === CMD SOLDIERS ===
  {
    id: 31,
    name: "MANNY",
    era: "CMD Rise",
    age: null,
    role: "CMD Soldier",
    archetype: "The Silent Weapon",
    faction: "CMD Soldiers",
    description: "Broke a man's arms without being asked twice. Holds down East New York with Dino. Quiet. Efficient. Final.",
    status: "UNKNOWN",
    statusDetail: "East New York",
    dossier: {
      subject: "MANNY",
      aliases: "None",
      origin: "East New York, Brooklyn",
      active: "1985 — [SEALED]",
      method: "Violence without theater. Just results.",
      strengths: "Brutally efficient, silent, unshakable",
      flaws: "[REDACTED]",
      secretWound: "[CLASSIFIED]",
      threatLevel: 4,
      quote: "He didn't need to be told twice."
    }
  },
  {
    id: 32,
    name: "LITTLE D",
    era: "CMD Rise",
    age: null,
    role: "CMD Soldier",
    archetype: "The Natural",
    faction: "CMD Soldiers",
    description: "Recruited off a basketball court. Fast, eager, good instincts. The streets found him before the scouts did.",
    status: "UNKNOWN",
    statusDetail: "[CLASSIFIED]",
    dossier: {
      subject: "LITTLE D",
      aliases: "None",
      origin: "Brooklyn",
      active: "1986 — [SEALED]",
      method: "Speed and instinct.",
      strengths: "Fast, adaptable, fearless",
      flaws: "[REDACTED]",
      secretWound: "[CLASSIFIED]",
      threatLevel: 2,
      quote: "The court or the corner. Same game."
    }
  },
  {
    id: 33,
    name: "CARMEN",
    era: "CMD Rise",
    age: null,
    role: "CMD Runner",
    archetype: "The Shadow Network",
    faction: "CMD Soldiers",
    description: "Ran a crew of female runners handling drops men couldn't. Invisible where it mattered most.",
    status: "UNKNOWN",
    statusDetail: "[CLASSIFIED]",
    dossier: {
      subject: "CARMEN",
      aliases: "None",
      origin: "Brooklyn",
      active: "1986 — [SEALED]",
      method: "Female runner network. Drops men couldn't touch.",
      strengths: "Invisibility, logistics, trust",
      flaws: "[REDACTED]",
      secretWound: "[CLASSIFIED]",
      threatLevel: 2,
      quote: "Nobody watches the women. That's the point."
    }
  },
  {
    id: 34,
    name: "ELIJAH",
    era: "CMD Rise",
    age: null,
    role: "CMD Chemist",
    archetype: "The Scientist",
    faction: "CMD Soldiers",
    description: "Cornell-expelled chemist. Brought scientific precision to CMD's operation. The upgrade from street cooking to 92% purity.",
    status: "UNKNOWN",
    statusDetail: "[CLASSIFIED]",
    dossier: {
      subject: "ELIJAH",
      aliases: "None",
      origin: "Ithaca → Brooklyn",
      active: "1987 — [SEALED]",
      method: "Chemistry. Precision. The science of the streets.",
      strengths: "Genius-level chemistry, discipline, methodical",
      flaws: "[REDACTED]",
      secretWound: "[CLASSIFIED]",
      threatLevel: 2,
      quote: "Purity is everything."
    }
  },
  {
    id: 35,
    name: "OLD MAN REESE",
    era: "CMD Rise",
    age: null,
    role: "CMD Affiliate",
    archetype: "The Absorbed Veteran",
    faction: "CMD Soldiers",
    description: "Originally a rival numbers runner. Paid off and displaced peacefully. Later absorbed into CMD as a street veteran.",
    status: "CLASSIFIED",
    statusDetail: "[SEALED]",
    dossier: {
      subject: "OLD MAN REESE",
      aliases: "Reese",
      origin: "Brooklyn",
      active: "1970s — [SEALED]",
      method: "Numbers. The old way. Then adaptation.",
      strengths: "Street knowledge, decades of connections, survival instinct",
      flaws: "[REDACTED]",
      secretWound: "[CLASSIFIED]",
      threatLevel: 1,
      quote: "You don't fight the tide. You float."
    }
  },
  // === RIVALS & ANTAGONISTS ===
  {
    id: 36,
    name: "SUPREMO",
    era: "CMD Rise",
    age: null,
    role: "Antagonist",
    archetype: "The Old Guard",
    faction: "Washington Heights",
    description: "Washington Heights boss. Survivor of the heroin and crack eras. Ran the Spanish connection CMD displaced. Smart enough to see what was coming.",
    status: "CLASSIFIED",
    statusDetail: "[SEALED]",
    dossier: {
      subject: "SUPREMO",
      aliases: "None",
      origin: "Washington Heights",
      active: "1970s — [SEALED]",
      method: "The Spanish connection. Old school supply chain.",
      strengths: "Experience, network, survival instincts",
      flaws: "[REDACTED]",
      secretWound: "[SEALED]",
      threatLevel: 4,
      quote: "You're not drug dealers. You're vampires."
    }
  },
  {
    id: 37,
    name: 'RICO (SKI CREW)',
    era: "Origins",
    age: null,
    role: "Antagonist",
    archetype: "The Triggerman",
    faction: "Ski Crew",
    description: "Ski crew lieutenant. Led the ambush at the Red Hook docks. The name the streets whisper when they talk about what started it all.",
    status: "CLASSIFIED",
    statusDetail: "[SEALED]",
    dossier: {
      subject: "RICO — SKI CREW",
      aliases: "None",
      origin: "Red Hook, Brooklyn",
      active: "1970s — [SEALED]",
      method: "Ambush. The docks.",
      strengths: "Ruthless, decisive",
      flaws: "[REDACTED]",
      secretWound: "[SEALED]",
      threatLevel: 3,
      quote: "[FILE SEALED]"
    }
  },
  {
    id: 38,
    name: "TONE",
    era: "CMD Rise",
    age: null,
    role: "Antagonist",
    archetype: "The Reckless King",
    faction: "Ghetto Mafia (GMC)",
    description: "Queens-based. Reckless, no code, no rules. Hit CMD corners. The streets taught him the price of disrespect.",
    status: "CLASSIFIED",
    statusDetail: "[SEALED]",
    dossier: {
      subject: "TONE — GHETTO MAFIA",
      aliases: "None",
      origin: "Queens → Brooklyn",
      active: "1980s — [SEALED]",
      method: "Reckless aggression. No code.",
      strengths: "Fearless, unpredictable",
      flaws: "[REDACTED]",
      secretWound: "[SEALED]",
      threatLevel: 3,
      quote: "Rules are for people who lose."
    }
  },
  {
    id: 39,
    name: "GOLIATH",
    era: "CMD Rise",
    age: null,
    role: "Rival → Affiliate",
    archetype: "The Yielder",
    faction: "8-Ball Crew",
    description: "Old school Brownsville. Dealt weed and heroin, missed the crack wave. CMD flooded his territory until he had no choice. He folded — then adapted.",
    status: "UNKNOWN",
    statusDetail: "Brownsville",
    dossier: {
      subject: "GOLIATH — 8-BALL CREW",
      aliases: "None",
      origin: "Brownsville, Brooklyn",
      active: "1980s — [SEALED]",
      method: "Old school product. Then surrender.",
      strengths: "Adaptability, street presence",
      flaws: "[REDACTED]",
      secretWound: "[CLASSIFIED]",
      threatLevel: 2,
      quote: "The smart ones bend. The dead ones don't."
    }
  },
  {
    id: 40,
    name: "KING CYRUS",
    era: "CMD Rise",
    age: null,
    role: "Rival → Absorbed",
    archetype: "The Proud King",
    faction: "Linden Boulevard Kings",
    description: "East Flatbush. Proud, organized, old school. Was already losing a war. Anton offered to destroy his enemies in exchange for absorption. Cyrus bent the knee.",
    status: "UNKNOWN",
    statusDetail: "East Flatbush",
    dossier: {
      subject: "KING CYRUS — LINDEN BLVD KINGS",
      aliases: "Cyrus",
      origin: "East Flatbush, Brooklyn",
      active: "1980s — [SEALED]",
      method: "Old school pride. Until the math changed.",
      strengths: "Organization, loyalty from his crew, pride",
      flaws: "[REDACTED]",
      secretWound: "[CLASSIFIED]",
      threatLevel: 3,
      quote: "A king kneels once. Then he learns."
    }
  },
  // === POWER BROKERS ===
  {
    id: 41,
    name: "PAPO",
    era: "Origins",
    age: null,
    role: "Supplier",
    archetype: "The Family Man",
    faction: "Bushwick Network",
    description: "Puerto Rican supplier in Bushwick. Ran the warehouse operation that fed Tio's network. Remembered names, birthdays, made everyone feel like family.",
    status: "CLASSIFIED",
    statusDetail: "[SEALED]",
    dossier: {
      subject: "PAPO",
      aliases: "None",
      origin: "Bushwick, Brooklyn",
      active: "1970s — [SEALED]",
      method: "Relationships. Loyalty. 'That's the point.'",
      strengths: "Community trust, supply chain management, warmth",
      flaws: "[REDACTED]",
      secretWound: "[CLASSIFIED]",
      threatLevel: 2,
      quote: "That's the point."
    }
  },
  {
    id: 42,
    name: "KING AKEEM",
    era: "CMD Rise",
    age: null,
    role: "Neutral Power",
    archetype: "The Moral Authority",
    faction: "Black Israelites",
    description: "Leader of the Black Israelites in Brownsville. Met CMD with moral authority instead of violence. Anton negotiated a boundary — respect, not war.",
    status: "UNKNOWN",
    statusDetail: "Brownsville",
    dossier: {
      subject: "KING AKEEM",
      aliases: "None",
      origin: "Brownsville, Brooklyn",
      active: "1980s — [SEALED]",
      method: "Moral authority. Sacred blocks.",
      strengths: "Community respect, spiritual power, discipline",
      flaws: "[REDACTED]",
      secretWound: "[CLASSIFIED]",
      threatLevel: 2,
      quote: "Some ground is sacred. You know the difference."
    }
  },
  {
    id: 43,
    name: "SHOGGY",
    era: "Origins",
    age: null,
    role: "Old Guard",
    archetype: "The Yellow Suit",
    faction: "Harlem",
    description: "Harlem pimp. Arrived at Tio's funeral in a blinding yellow suit. Pressed a massive stack of cash into Vincent's hands as tribute. Old Harlem respect.",
    status: "CLASSIFIED",
    statusDetail: "[SEALED]",
    dossier: {
      subject: "SHOGGY",
      aliases: "None",
      origin: "Harlem",
      active: "1970s — [SEALED]",
      method: "The old Harlem game. Presence. Tribute.",
      strengths: "Connections, showmanship, old money",
      flaws: "[REDACTED]",
      secretWound: "[CLASSIFIED]",
      threatLevel: 1,
      quote: "Respect is the only currency that never devalues."
    }
  },
  {
    id: 44,
    name: "DIABLO",
    era: "Origins",
    age: null,
    role: "Fighter",
    archetype: "The Old Muscle",
    faction: "De La Toros",
    description: "Leader of the De La Toros. Attended Tio's funeral. Assessed Anton directly. Old school muscle with old school loyalty.",
    status: "CLASSIFIED",
    statusDetail: "[SEALED]",
    dossier: {
      subject: "DIABLO — DE LA TOROS",
      aliases: "None",
      origin: "Brooklyn",
      active: "1970s — [SEALED]",
      method: "Fighting. The old way.",
      strengths: "Physical dominance, loyalty, reputation",
      flaws: "[REDACTED]",
      secretWound: "[CLASSIFIED]",
      threatLevel: 3,
      quote: "You training these boys?"
    }
  },
  {
    id: 45,
    name: "HENDERSON",
    era: "CMD Rise",
    age: null,
    role: "Corrupt Official",
    archetype: "The Bought Man",
    faction: "JFK Customs",
    description: "Corrupt JFK Customs official. Gambling debts retired by Vincent. Enabled the airport smuggling pipeline. A bought man, not a player.",
    status: "CLASSIFIED",
    statusDetail: "[SEALED]",
    dossier: {
      subject: "HENDERSON — JFK CUSTOMS",
      aliases: "None",
      origin: "New York",
      active: "1980s — [SEALED]",
      method: "Gambling debts made him cooperative.",
      strengths: "Access, clearance authority",
      flaws: "[REDACTED]",
      secretWound: "[CLASSIFIED]",
      threatLevel: 1,
      quote: "Everyone has a number. His was surprisingly low."
    }
  },
  {
    id: 46,
    name: "DETECTIVE SILAS",
    era: "Origins → CMD Rise",
    age: null,
    role: "Law Enforcement",
    archetype: "The Cynical Mentor",
    faction: "NYPD",
    description: "Rodriguez's mentor. 20-year veteran. Cynical but wise. Taught that you don't take down families in one bust — you chip away over decades.",
    status: "CLASSIFIED",
    statusDetail: "[SEALED]",
    dossier: {
      subject: "DETECTIVE SILAS — NYPD",
      aliases: "None",
      origin: "New York",
      active: "1960s — [SEALED]",
      method: "Patience. Decades. Chip away.",
      strengths: "Experience, wisdom, patience",
      flaws: "[REDACTED]",
      secretWound: "[CLASSIFIED]",
      threatLevel: 1,
      quote: "You don't take down families in one bust."
    }
  },
  // === MORE CMD SOLDIERS ===
  {
    id: 47,
    name: "TERRENCE",
    era: "CMD Rise",
    age: null,
    role: "CMD Runner",
    archetype: "The Spark",
    faction: "CMD Soldiers",
    description: "Runner who got branded with a cigarette by the Ski crew. His burned face became the catalyst for the Butcher Shop retaliation.",
    status: "CLASSIFIED",
    statusDetail: "[SEALED]",
    dossier: {
      subject: "TERRENCE",
      aliases: "None",
      origin: "Brooklyn",
      active: "1980s — [SEALED]",
      method: "He didn't start the war. His face did.",
      strengths: "Loyalty, resilience",
      flaws: "[REDACTED]",
      secretWound: "[SEALED]",
      threatLevel: 1,
      quote: "They burned my face. CMD burned their world."
    }
  },
  {
    id: 48,
    name: "ARK",
    era: "CMD Rise",
    age: null,
    role: "CMD Cook (Interim)",
    archetype: "The Placeholder",
    faction: "CMD Soldiers",
    description: "Dino's cousin from Oklahoma. Prison-trained crack cook. Brought in to start production but proved careless. Replaced by Elijah.",
    status: "CLASSIFIED",
    statusDetail: "[SEALED]",
    dossier: {
      subject: "ARK",
      aliases: "None",
      origin: "Oklahoma → Brooklyn",
      active: "1985 — [SEALED]",
      method: "Prison-trained chemistry. Not enough.",
      strengths: "Willingness, availability",
      flaws: "[REDACTED]",
      secretWound: "[CLASSIFIED]",
      threatLevel: 1,
      quote: "He could cook. He just couldn't be careful."
    }
  },
  {
    id: 49,
    name: '"TORO"',
    era: "CMD Rise",
    age: null,
    role: "Antagonist",
    archetype: "The Rogue Enforcer",
    faction: "Washington Heights",
    description: "Supremo's rogue enforcer. Refused to pay CMD's 20% logistics fee. Triggered the Battle of 161st Street near Yankee Stadium.",
    status: "CLASSIFIED",
    statusDetail: "[SEALED]",
    dossier: {
      subject: "TORO — ROGUE ENFORCER",
      aliases: "None",
      origin: "Washington Heights",
      active: "1980s — [SEALED]",
      method: "Hijacked a CMD van near Yankee Stadium. Bad decision.",
      strengths: "Fearless, aggressive",
      flaws: "[REDACTED]",
      secretWound: "[SEALED]",
      threatLevel: 3,
      quote: "He refused the 20%. The streets collected 100%."
    }
  },
  {
    id: 50,
    name: '"BLOODY MONEY MARK"',
    era: "CMD Rise",
    age: null,
    role: "CMD Soldier",
    archetype: "The Name on the Hoodie",
    faction: "CMD Soldiers",
    description: "CMD soldier. His name is literally on the hoodie — the figure everyone sees but nobody can identify. Street general energy.",
    status: "UNKNOWN",
    statusDetail: "[CLASSIFIED]",
    dossier: {
      subject: "BLOODY MONEY MARK",
      aliases: "BMM",
      origin: "Brooklyn",
      active: "1980s — [SEALED]",
      method: "Street presence. The name on the fabric.",
      strengths: "Visibility, reputation, loyalty",
      flaws: "[REDACTED]",
      secretWound: "[CLASSIFIED]",
      threatLevel: 3,
      quote: "If you know the name, you know the block."
    }
  },
  {
    id: 51,
    name: '"BLACK"',
    era: "Origins",
    age: null,
    role: "Antagonist",
    archetype: "The First Enemy",
    faction: "Ski Crew",
    description: "Leader of the Ski Crew. Haitian crew out of Red Hook. Ordered the hit on Tio at the docks. CMD's first war ended in the apartment above the Butcher Shop.",
    status: "CLASSIFIED",
    statusDetail: "[SEALED]",
    dossier: {
      subject: "BLACK — SKI CREW LEADER",
      aliases: "None",
      origin: "Haiti → Red Hook, Brooklyn",
      active: "1970s — [SEALED]",
      method: "Ambush. The docks. The old Haitian network.",
      strengths: "Ruthless, organized, controlled Red Hook",
      flaws: "[REDACTED]",
      secretWound: "[SEALED]",
      threatLevel: 4,
      quote: "[FILE SEALED — BUTCHER SHOP INCIDENT]"
    }
  }
];

export const quizQuestions = [
  {
    id: 1,
    question: "When the block goes quiet, you...",
    options: [
      { id: "A", text: "Move first" },
      { id: "B", text: "Wait and watch" },
      { id: "C", text: "Call your lawyer" },
      { id: "D", text: "Get ghost" }
    ]
  },
  {
    id: 2,
    question: "Loyalty means...",
    options: [
      { id: "A", text: "Dying for it" },
      { id: "B", text: "Earning it" },
      { id: "C", text: "Owning it" },
      { id: "D", text: "Questioning it" }
    ]
  },
  {
    id: 3,
    question: "The money's dirty. You...",
    options: [
      { id: "A", text: "Clean it" },
      { id: "B", text: "Spend it" },
      { id: "C", text: "Bury it" },
      { id: "D", text: "Flip it" }
    ]
  },
  {
    id: 4,
    question: "The feds are watching. You...",
    options: [
      { id: "A", text: "Go legit" },
      { id: "B", text: "Go harder" },
      { id: "C", text: "Go quiet" },
      { id: "D", text: "Go missing" }
    ]
  },
  {
    id: 5,
    question: "The water remembers...",
    options: [
      { id: "A", text: "Everything" },
      { id: "B", text: "Nothing" },
      { id: "C", text: "Only what matters" },
      { id: "D", text: "Only the bodies" }
    ]
  }
];

export const quizResults = {
  CMD: {
    name: "CMD",
    description: "You're built for the empire. Anton sees you. Calculated. Hungry. Willing to build something from nothing — and walk back into a city that tried to bury you with that same energy. The streets made you, but they don't own you."
  },
  CONSIGLIERE: {
    name: "THE CONSIGLIERE",
    description: "Smart. Careful. You play chess while others play checkers. You're the one everyone needs in the room. The intelligence behind the power. You can pivot between street and boardroom without missing a step."
  },
  BURNER: {
    name: "THE BURNER",
    description: "You move in the shadows. Nobody knows your name. That's the point. Military discipline meets street instinct. Clout is loud. Control is quiet."
  },
  EVOLUTION: {
    name: "THE EVOLUTION",
    description: "You got out. Or tried to. The water still remembers. You took your cut and found a door. Built something legitimate on the other side. It's harder to stay clean than it ever was to get dirty — but you've already paid that price."
  }
};

export const series = {
  waterfront: {
    title: "KILLING OVER WATER: THE WATERFRONT DISTRICT",
    subtitle: "2026. Anton is out. Vincent's empire is collapsing. And someone is about to burn it down from the inside.",
    logline: "After twenty years in the system, Anton returns to the Waterfront like a rumor — quiet, patient, surgical. He doesn't roar; he erases. He takes product, not cash, and begins a campaign of invisible sabotage. No loose money. Everything digital. Monopoly, not mayhem.",
    status: "IN DEVELOPMENT",
    seasons: [
      {
        number: 1,
        title: "THE REAPER OF THE WATERFRONT",
        tagline: "Anton returns after 20 years. The city doesn't know he's back. Vincent doesn't know he's being watched.",
        episodes: [
          { number: 1, title: "THE RETURN", teaser: "Anton released. 66 years old. East New York has changed. He hasn't." },
          { number: 2, title: "THE SHOP", teaser: "Navy Tech is more than a repair shop. The Brownsville hit sets everything in motion." },
          { number: 3, title: "THE FOLLOW", teaser: "Anton tails Vincent through the city. Juny steals from his father. The collision in the lobby." },
          { number: 4, title: "THE OFFER", teaser: "Anton walks into Juny's shop with a duffle bag and a message. The warehouse. Raul falls." }
        ]
      },
      {
        number: 2,
        title: "THE RECKONING",
        tagline: "The secret about Lena explodes. Vincent faces what he did.",
        episodes: [
          { number: 1, title: "[CLASSIFIED]", teaser: "IN DEVELOPMENT" },
          { number: 2, title: "[CLASSIFIED]", teaser: "IN DEVELOPMENT" },
          { number: 3, title: "[CLASSIFIED]", teaser: "IN DEVELOPMENT" },
          { number: 4, title: "[CLASSIFIED]", teaser: "IN DEVELOPMENT" }
        ]
      },
      {
        number: 3,
        title: "THE FINAL WAR",
        tagline: "Papi returns. One last battle for the waterfront.",
        episodes: [
          { number: 1, title: "[CLASSIFIED]", teaser: "IN DEVELOPMENT" },
          { number: 2, title: "[CLASSIFIED]", teaser: "IN DEVELOPMENT" },
          { number: 3, title: "[CLASSIFIED]", teaser: "IN DEVELOPMENT" },
          { number: 4, title: "[CLASSIFIED]", teaser: "IN DEVELOPMENT" }
        ]
      },
      {
        number: 4,
        title: "THE BLOOD WAR",
        tagline: "Everything ends where it began. The water. The reckoning.",
        episodes: [
          { number: 1, title: "[CLASSIFIED]", teaser: "IN DEVELOPMENT" },
          { number: 2, title: "[CLASSIFIED]", teaser: "IN DEVELOPMENT" },
          { number: 3, title: "[CLASSIFIED]", teaser: "IN DEVELOPMENT" },
          { number: 4, title: "[CLASSIFIED]", teaser: "IN DEVELOPMENT" }
        ]
      }
    ]
  },
  vip: {
    title: "V.I.P.",
    subtitle: "A man left his past behind with one idea: build something nobody could touch.",
    logline: "A prestige dramedy about a nightclub staff fighting for money, status, and survival while their manager hides a past tied to Coke Money District and the fallout of Ski Mask Way. Nightlife chaos meets workplace dysfunction meets slow-burn thriller.",
    status: "LOCKED — IN DEVELOPMENT",
    locked: true,
    note: "Bridge series between SKI MASK WAY and WATERFRONT DISTRICT. What happens in LA nightclubs — and the Persians who circle there — will explode on the Brooklyn waterfront twenty years later.",
    corePremise: "Everything revolves around one metric: who sells the most VIP tables. The monthly competition drives rivalries, alliances, sabotage, romance, and secrets.",
    hiddenStory: "[CLASSIFIED]",
    characters: [
      { name: "[CLASSIFIED]", role: "Club Owner", truth: "[CLASSIFIED]" },
      { name: "Amber Lane", role: "Assistant Manager", truth: "[CLASSIFIED]" },
      { name: "Marcus James", role: "Staff Manager / Head of Security", truth: "[CLASSIFIED]" },
      { name: "Jordan 'Jinx' Caldwell", role: "Head Bartender", truth: "[CLASSIFIED]" },
      { name: "Leo 'Vibe' Washington", role: "Resident DJ", truth: "[CLASSIFIED]" },
      { name: "Skyla Torres", role: "Lead Bottle Server", truth: "[CLASSIFIED]" },
      { name: "Desiree 'Dez' Monroe", role: "Bottle Server", truth: "[CLASSIFIED]" },
      { name: "Keisha 'Kiki' Brown", role: "Bottle Server", truth: "[CLASSIFIED]" },
      { name: "Riley Carter", role: "Server", truth: "[CLASSIFIED]" },
      { name: "Xavier 'XL' Lawson", role: "Host / Promoter", truth: "[CLASSIFIED]" },
      { name: "Kyle", role: "Dishwasher", truth: "[CLASSIFIED]" },
      { name: "Natalie 'Nat' Hayes", role: "Rival Promoter", truth: "[CLASSIFIED]" },
      { name: "Nathan Hayes", role: "Rival Promoter", truth: "[CLASSIFIED]" },
      { name: "Eva Martinez", role: "Event Planner", truth: "[CLASSIFIED]" }
    ],
    pilot: {
      title: "EPISODE 1 — PILOT",
      tagline: "[CLASSIFIED]",
      scenes: [
        { number: 1, title: "[CLASSIFIED]", location: "[CLASSIFIED]", teaser: "[CLASSIFIED]" },
        { number: 2, title: "[CLASSIFIED]", location: "[CLASSIFIED]", teaser: "[CLASSIFIED]" },
        { number: 3, title: "[CLASSIFIED]", location: "[CLASSIFIED]", teaser: "[CLASSIFIED]" },
        { number: 4, title: "[CLASSIFIED]", location: "[CLASSIFIED]", teaser: "[CLASSIFIED]" },
        { number: 5, title: "[CLASSIFIED]", location: "[CLASSIFIED]", teaser: "[CLASSIFIED]" },
        { number: 6, title: "[CLASSIFIED]", location: "[CLASSIFIED]", teaser: "[CLASSIFIED]" },
        { number: 7, title: "[CLASSIFIED]", location: "[CLASSIFIED]", teaser: "[CLASSIFIED]" },
        { number: 8, title: "[CLASSIFIED]", location: "[CLASSIFIED]", teaser: "[CLASSIFIED]" },
        { number: 9, title: "[CLASSIFIED]", location: "[CLASSIFIED]", teaser: "[CLASSIFIED]" }
      ]
    }
  }
};

export const themes = [
  { title: "NO LOOSE MONEY", description: "Every dollar has a paper trail or a body. Loose money is a liability." },
  { title: "MONOPOLY NOT MAYHEM", description: "The goal was never violence. The goal was control. Violence is just the price of resistance." },
  { title: "FAMILY AS WEAPON", description: "The people closest to you are either your greatest asset or your greatest vulnerability. Sometimes both." },
  { title: "TRANSFORMATION NOT LOYALTY", description: "The ones who survive don't stay the same. Loyalty is a season. Transformation is forever." },
  { title: "LEGITIMACY IS FRAGILE", description: "The boardroom is just the corner with better lighting. One audit can end an empire faster than a bullet." },
  { title: "THE MUSIC COVERS THE MONEY", description: "From Rico to Big Rich to the clubs — the culture was always the cleanest pipeline." }
];

export const glossary = [
  { term: "CMD", definition: "Coke Money District — the original empire" },
  { term: "City Made Dynasty", definition: "CMD's legitimate record label evolution" },
  { term: "V.I.P.", definition: "A legitimate nightclub in Los Angeles — ownership classified" },
  { term: "Navy Tech", definition: "Juny's electronics shop — legitimate front, illegitimate operation underneath" },
  { term: "The Waterfront District", definition: "Vincent's casino and real estate development on the Brooklyn waterfront" },
  { term: "Money Park Gang (MPG)", definition: "East Coast rap group — Red Eye, Ty, Cash, and others" },
  { term: "Boro Gem Music", definition: "Record label endorsed by Mateo that launched MPG" },
  { term: "DDN", definition: "Dominican Dope Nation — rises under Raul in the MPG era" },
  { term: "BGM", definition: "Bronx faction formed during Ski Mask Way" },
  { term: "PAW", definition: "Pills and Weed — formed during the Ski Mask Way era" },
  { term: "Los Diablos", definition: "California crew involved in the heist that changed everything" },
  { term: "Red Serpents", definition: "Chuck Wong's gambling organization" },
  { term: "The Blue Wall", definition: "NYPD code of silence — broken when it mattered most" },
  { term: "The Judas Protocol", definition: "DEA strategy leveraging insider betrayal" },
  { term: "The Devoe Play", definition: "Claude Devoe's money laundering method — electronics stores as legitimate fronts" },
  { term: "The Logistics Fee", definition: "CMD toll for operating in their territory" },
  { term: "Peruvian White", definition: "92% pure — the supply that fueled the empire" },
  { term: "Panda Twin", definition: "Mateo — the shadow supplier" }
];
